import { useState } from 'react';
import { Box, Typography, Alert, TextField } from '@mui/material';
import ConfigCard from '../shared/ConfigCard';
import useHoneytokensStatuses from '../../hooks/useHoneytokensStatuses';

function HoneytokensTab() {
  const { 
    honeytokensStatuses, 
    error: statusError,
    updateStatus 
  } = useHoneytokensStatuses();
  
  const [loadingHoneytokens, setLoadingHoneytokens] = useState({});
  const [honeytokenError, setHoneytokenError] = useState(null);
  const [userName, setUserName] = useState('');

  const handleHoneytokenToggle = async (honeytokenName) => {
    setHoneytokenError(null);
    const isCurrentlyEnabled = honeytokensStatuses[honeytokenName]?.enabled;

    setLoadingHoneytokens(prev => ({ 
      ...prev, 
      [honeytokenName]: true 
    }));

    const success = await updateStatus(honeytokenName, !isCurrentlyEnabled, userName);
    
    if (!success) {
      setHoneytokenError(`Failed to ${isCurrentlyEnabled ? 'disable' : 'enable'} ${honeytokenName}`);
    }
    
    setLoadingHoneytokens(prev => ({ 
      ...prev, 
      [honeytokenName]: false 
    }));
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        Honeytokens Configurations
      </Typography>
      
      {(honeytokenError || statusError) && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {honeytokenError || statusError}
        </Alert>
      )}
      
      <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
        General Configurations
      </Typography>
      
      <Box sx={{ mb: 3 }}>
        <TextField
          label="Email Address"
          variant="outlined"
          size="small"
          value={userName}
          onChange={(e) => setUserName(e.target.value)}
          placeholder="Enter email address"
          fullWidth
        />
      </Box>
      
      {Object.keys(honeytokensStatuses)
        .map((honeytokenName) => (
          <ConfigCard
            key={honeytokenName}
            title={honeytokenName}
            enabled={honeytokensStatuses[honeytokenName]?.enabled || false}
            loading={loadingHoneytokens[honeytokenName]}
            onToggle={() => handleHoneytokenToggle(honeytokenName)}
            showToggle={true}
          />
        ))}
    </Box>
  );
}

export default HoneytokensTab; 